export var report = {
    900: '#174938',
    800: '#216452',
    700: '#27745F',
    600: '#2C846E',
    500: '#30917A',
    400: '#41A18C',
    300: '#5CB29F',
    200: '#87C8BA',
    100: '#B5DDD5',
    50: '#E1F1EE',
};
//# sourceMappingURL=report.js.map